<!-- =========================================================================================
    File Name: LoadingDefault.vue
    Description: Add default loading to your application
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
    CRUD_Account_Get CRUD_Account_Get
    https://localhost:44341/api/FAMS/SP_JsonResult?storeproc=CRUD_Account_Get&parameters=1
========================================================================================== -->


<template>
  <div class="vs-con-loading__container">
    <div>
      <vx-card ref="MainCard2" v-show="!isInfoHidden">
        <div class="mt-5">
          <div class="vx-row">
            <div class="vx-col md:w-1/6 w-full">
              <vs-button color="warning" type="border" class="rounded-lg mb-2" @click="cancelAdd">Return</vs-button>
            </div>
            <div class="vx-col md:w-1/8 w-full">
              <vs-button color="warning" type="border" class="rounded-lg mb-2" @click="initValues">Restart</vs-button>
            </div>
          </div>

          <form-wizard ref="wizard" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)"
            :title="title" style="overflow-x: scroll;" :subtitle="subtitle" finishButtonText="Save entry" @on-complete="saveContactInfo">
            <tab-content title="Step 1" class="mb-5" icon="feather icon-home">
              <!-- tab 1 content -->
              <div class="notify-section">
                <h5 class="notify-section-title">Contact Details</h5>
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full mt-4">
                    <vs-input label="User Name" v-model="formData.name" class="w-full" />
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-4">
                    <vs-input label="User Surname" v-model="formData.surname" class="w-full" />
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full mt-4">
                    <vs-input label="Mobile Phone Number (with international code e.g. +27123456789)"
                      placeholder="+27123456789" v-model="formData.phoneNumber" class="w-full" />
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-4">
                    <vs-input label="Email Address" v-model="formData.emailaddress" class="w-full" />
                  </div>
                </div>
              </div>

              <div class="notify-section">
                <h5 class="notify-section-title">Chat Bot</h5>
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full mt-4">
                    <label class="w-full">Select FAMS Chat Bot</label>
                    <v-select :options="chatBots" placeholder="Select FAMS Chat Bot" v-model="selectedChatBot" />
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-4">
                    <p class="notify-hint">Please make sure valid information for the chat bot is entered.</p>
                    <p class="notify-hint">Enter the number used to register on the platform of the chat bot.</p>
                  </div>
                </div>
              </div>

              <div class="notify-section" v-show="selectedChatBot.value == 3 || selectedChatBot.value == 4 || selectedChatBot.value == 5">
                <h5 class="notify-section-title">Notification Types</h5>
                <p class="notify-hint mb-3">Tick each alert this contact should receive. Once ticked, optionally
                  assign a schedule profile to that specific type — leave it on "Default" to fall back to the
                  schedule set below.</p>
                <div class="notify-type-grid">
                  <div class="notify-type-card">
                    <div class="notify-type-card-header">General Notifications</div>
                    <div class="notify-type-card-body">
                      <div class="notify-type-row" :class="{'notify-type-row--all': type.code && type.code.toUpperCase() === 'ALL'}"
                        :key="index" v-for="(type, index) in formData.notifications">
                        <vs-checkbox v-model="type.isSelected" @change="onNotificationChange(type)">{{ type.code }}</vs-checkbox>
                        <v-select v-if="type.isSelected" :options="notificationProfiles" placeholder="Default"
                          v-model="type.profile" @input="onProfileChange(type, $event)" class="notify-type-profile-select" />
                      </div>
                    </div>
                  </div>
                  <div class="notify-type-card">
                    <div class="notify-type-card-header">ATG Notifications</div>
                    <div class="notify-type-card-body">
                      <div class="notify-type-row" :class="{'notify-type-row--all': type.code && type.code.toUpperCase() === 'ALL'}"
                        :key="index" v-for="(type, index) in formData.atgNotifications">
                        <vs-checkbox v-model="type.isSelected" @change="onNotificationChange(type)">{{ type.code }}</vs-checkbox>
                        <v-select v-if="type.isSelected" :options="notificationProfiles" placeholder="Default"
                          v-model="type.profile" @input="onProfileChange(type, $event)" class="notify-type-profile-select" />
                      </div>
                    </div>
                  </div>
                  <div class="notify-type-card">
                    <div class="notify-type-card-header">FMS Notifications</div>
                    <div class="notify-type-card-body">
                      <div class="notify-type-row" :class="{'notify-type-row--all': type.code && type.code.toUpperCase() === 'ALL'}"
                        :key="index" v-for="(type, index) in formData.fmsNotifications">
                        <vs-checkbox v-model="type.isSelected" @change="onNotificationChange(type)">{{ type.code }}</vs-checkbox>
                        <v-select v-if="type.isSelected" :options="notificationProfiles" placeholder="Default"
                          v-model="type.profile" @input="onProfileChange(type, $event)" class="notify-type-profile-select" />
                      </div>
                    </div>
                  </div>
                  <div class="notify-type-card">
                    <div class="notify-type-card-header">IOT (FMC) Notifications</div>
                    <div class="notify-type-card-body">
                      <div class="notify-type-row" :class="{'notify-type-row--all': type.code && type.code.toUpperCase() === 'ALL'}"
                        :key="index" v-for="(type, index) in formData.iotNotifications">
                        <vs-checkbox v-model="type.isSelected" @change="onNotificationChange(type)">{{ type.code }}</vs-checkbox>
                        <v-select v-if="type.isSelected" :options="notificationProfiles" placeholder="Default"
                          v-model="type.profile" @input="onProfileChange(type, $event)" class="notify-type-profile-select" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="notify-section" v-show="selectedChatBot.value == 3 || selectedChatBot.value == 4 || selectedChatBot.value == 5">
                <h5 class="notify-section-title">Default Schedule</h5>
                <p class="notify-hint mb-3">Used for any notification type above that isn't assigned its own profile.</p>
                <div class="vx-row">
                  <div class="vx-col mb-2 w-1/2">
                    <vs-checkbox v-model="continuous">Continuous Notification</vs-checkbox>
                  </div>
                  <div class="vx-col mb-2 w-1/2">
                    <label class="w-full">Select Notification Schedule</label>
                    <v-select :options="notificationSchedules" placeholder="Select Schedule"
                      v-model="selectedSchedule" />
                  </div>
                </div>
              </div>
            </tab-content>
          </form-wizard>
        </div>
      </vx-card>
      <vx-card ref="MainCard" v-show="!isListHidden">
        <div>
          <vs-table ref="gridTable" v-model="selected" pagination :max-items="itemsPerPage" search
            :data="contactInfoData" class="vs-con-loading__container">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
              <!-- ADD NEW -->
              <vs-button class="rounded-lg mr-2" color="warning" type="filled" @click="GetContactInfo()"
                icon-pack="feather" icon="icon-refresh-ccw">Reload</vs-button>
              <vs-button class="rounded-lg mr-2" color="success" type="filled" @click="addContactInfo"
                icon-pack="feather" icon="icon-plus-square">Add New</vs-button>
              <vs-button class="rounded-lg mr-2" color="primary" type="filled" @click="openManageProfiles"
                icon-pack="feather" icon="icon-clock">Manage Profiles</vs-button>
              <!-- ITEMS PER PAGE -->
              <vs-dropdown vs-trigger-click class="cursor-pointer mr-4">
                <div
                  class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{
                    contactInfoData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage :
                    contactInfoData.length }} of {{ contactInfoData.length }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="rounded-lg btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 50">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 100">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
            <template slot="thead">
              <vs-th sort-key="name">Name</vs-th>
              <vs-th sort-key="surname">Surname</vs-th>
              <vs-th sort-key="emailaddress">Email</vs-th>
              <vs-th sort-key="phoneNumber">Phone Number</vs-th>
              <vs-th sort-key="chatBot">Chat Bot</vs-th>
              <vs-th>Action</vs-th>
            </template>
            <!-- visible: false -->
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.name">{{ tr.name }}</vs-td>
                <vs-td :data="tr.surname">{{ tr.surname }}</vs-td>
                <vs-td :data="tr.emailaddress">{{ tr.emailaddress }}</vs-td>
                <vs-td :data="tr.phoneNumber">{{ tr.phoneNumber }}</vs-td>
                <vs-td :data="tr.chatBot">{{ tr.chatBot }}</vs-td>
                <vs-td id="iconContainer" class="whitespace-no-wrap">
                  <vx-tooltip class="flex" text="Edit Contact Info">
                    <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      @click.stop="openContactInfoPopup(tr)" />
                  </vx-tooltip>
                  <vx-tooltip class="flex" text="Delete Contact Info">
                    <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                      @click.stop="deleteContactInfo(tr)" />
                  </vx-tooltip>
                  <vx-tooltip text="Generate QR Code">
                    <feather-icon icon="GridIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      @click.stop="generateQR(tr)" />
                  </vx-tooltip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
      <vs-popup class="notify-wide-popup" title="Edit Contact Information" :active.sync="popupContactInfo">
        <div class="vx-col md:w-full w-full mb-5">
          <div class="notify-section">
            <h5 class="notify-section-title">Contact Details</h5>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-4">
                <vs-input label="User Name" v-model="formData.name" class="w-full" />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-4">
                <vs-input label="User Surname" v-model="formData.surname" class="w-full" />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-4">
                <vs-input label="Mobile Phone Number (with international code e.g. +27123456789)"
                  placeholder="+27123456789" v-model="formData.phoneNumber" class="w-full" />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-4">
                <vs-input label="Email Address" v-model="formData.emailaddress" class="w-full" />
              </div>
            </div>
          </div>

          <div class="notify-section">
            <h5 class="notify-section-title">Chat Bot</h5>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-4">
                <label class="w-full">Select FAMS Chat Bot</label>
                <v-select :options="chatBots" placeholder="Select FAMS Chat Bot" v-model="selectedChatBot" />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-4">
                <p class="notify-hint">Please make sure valid information for the chat bot is entered.</p>
                <p class="notify-hint">Enter the number used to register on the platform of the chat bot.</p>
              </div>
            </div>
          </div>

          <div class="notify-section" v-show="selectedChatBot.value == 3 || selectedChatBot.value == 4 || selectedChatBot.value == 5">
            <h5 class="notify-section-title">Notification Types</h5>
            <p class="notify-hint mb-3">Tick each alert this contact should receive. Once ticked, optionally
              assign a schedule profile to that specific type — leave it on "Default" to fall back to the
              schedule set below.</p>
            <div class="notify-type-grid">
              <div class="notify-type-card">
                <div class="notify-type-card-header">General Notifications</div>
                <div class="notify-type-card-body">
                  <div class="notify-type-row" :class="{'notify-type-row--all': type.code && type.code.toUpperCase() === 'ALL'}"
                    :key="index" v-for="(type, index) in formData.notifications">
                    <vs-checkbox v-model="type.isSelected" @change="onNotificationChange(type)">{{ type.code }}</vs-checkbox>
                    <v-select v-if="type.isSelected" :options="notificationProfiles" placeholder="Default"
                      v-model="type.profile" @input="onProfileChange(type, $event)" class="notify-type-profile-select" />
                  </div>
                </div>
              </div>
              <div class="notify-type-card">
                <div class="notify-type-card-header">ATG Notifications</div>
                <div class="notify-type-card-body">
                  <div class="notify-type-row" :class="{'notify-type-row--all': type.code && type.code.toUpperCase() === 'ALL'}"
                    :key="index" v-for="(type, index) in formData.atgNotifications">
                    <vs-checkbox v-model="type.isSelected" @change="onNotificationChange(type)">{{ type.code }}</vs-checkbox>
                    <v-select v-if="type.isSelected" :options="notificationProfiles" placeholder="Default"
                      v-model="type.profile" @input="onProfileChange(type, $event)" class="notify-type-profile-select" />
                  </div>
                </div>
              </div>
              <div class="notify-type-card">
                <div class="notify-type-card-header">FMS Notifications</div>
                <div class="notify-type-card-body">
                  <div class="notify-type-row" :class="{'notify-type-row--all': type.code && type.code.toUpperCase() === 'ALL'}"
                    :key="index" v-for="(type, index) in formData.fmsNotifications">
                    <vs-checkbox v-model="type.isSelected" @change="onNotificationChange(type)">{{ type.code }}</vs-checkbox>
                    <v-select v-if="type.isSelected" :options="notificationProfiles" placeholder="Default"
                      v-model="type.profile" @input="onProfileChange(type, $event)" class="notify-type-profile-select" />
                  </div>
                </div>
              </div>
              <div class="notify-type-card">
                <div class="notify-type-card-header">IOT (FMC) Notifications</div>
                <div class="notify-type-card-body">
                  <div class="notify-type-row" :class="{'notify-type-row--all': type.code && type.code.toUpperCase() === 'ALL'}"
                    :key="index" v-for="(type, index) in formData.iotNotifications">
                    <vs-checkbox v-model="type.isSelected" @change="onNotificationChange(type)">{{ type.code }}</vs-checkbox>
                    <v-select v-if="type.isSelected" :options="notificationProfiles" placeholder="Default"
                      v-model="type.profile" @input="onProfileChange(type, $event)" class="notify-type-profile-select" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="notify-section" v-show="selectedChatBot.value == 3 || selectedChatBot.value == 4 || selectedChatBot.value == 5">
            <h5 class="notify-section-title">Default Schedule</h5>
            <p class="notify-hint mb-3">Used for any notification type above that isn't assigned its own profile.</p>
            <div class="vx-row">
              <div class="vx-col mb-2 w-1/2">
                <vs-checkbox v-model="continuous">Continuous Notification</vs-checkbox>
              </div>
              <div class="vx-col mb-2 w-1/2">
                <label class="w-full">Select Notification Schedule</label>
                <v-select :options="notificationSchedules" placeholder="Select Schedule" v-model="selectedSchedule" />
              </div>
            </div>
          </div>

          <vs-button ref="saveButton" class="rounded-lg mt-3 mr-3 vs-con-loading__container" color="success"
            type="border" @click="saveContactInfo()">Save
          </vs-button>
          <vs-button class="rounded-lg mt-3 mr-3" color="warning" type="border" @click="closeContactInfoPopup()">Cancel
          </vs-button>
        </div>
      </vs-popup>
      <vs-popup title="Equipment QR Code" :active.sync="popupGenerateQR">
        <div class="vx-col md:w-full w-full mb-5">
          <div id="qrCode" ref="qrCode" name="qrCode" class="m-1/2 md-full ml-3">
            <label class="w-full">Scan to open on {{ registeredBot }} and send the typed message</label>
            <br />
            <div class="vx-row px-4 pb-3">
              <qr-code :size="150" :text="registeredBotUrl"></qr-code>
            </div>
            <div class="vx-row px-4 pb-3" style="flex-flow: column;">
              <p><a style="color: black;" :href="registeredBotUrl" target="_blank" class="w-full mt-3 mr-3">Or click
                  here to open on Web Browser / Or desktop app</a></p>
              <span style="white-space: pre;"></span>
            </div>
          </div>
          <!-- <vs-button ref="saveButton" class="rounded-lg mt-3 mr-3 vs-con-loading__container" color="success" type="border"
          @click="printQR()">Print QR
        </vs-button>
        <vs-button ref="saveButton" class="rounded-lg mt-3 mr-3 vs-con-loading__container" color="success" type="border"
          @click="saveQR()">Save QR
        </vs-button> -->
          <vs-button class="rounded-lg mt-3 mr-3" color="warning" type="border" @click="closeQRPopup()">Cancel
          </vs-button>
        </div>
      </vs-popup>
      <vs-popup title="Manage Notification Profiles" :active.sync="popupManageProfiles">
        <div class="vx-col md:w-full w-full mb-5">
          <p class="mb-3">Create named schedule presets (e.g. "Fast", "Hourly Digest") once here, then assign one to
            each notification type below — different types for the same contact can use different profiles.</p>
          <vs-table :data="notificationProfiles" class="mb-5">
            <template slot="thead">
              <vs-th>Name</vs-th>
              <vs-th>Continuous</vs-th>
              <vs-th>Schedule</vs-th>
              <vs-th>Action</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="pr" :key="indexpr" v-for="(pr, indexpr) in data">
                <vs-td :data="pr.name">{{ pr.name }}</vs-td>
                <vs-td :data="pr.continuousNotify">{{ pr.continuousNotify == 1 ? 'Yes' : 'No' }}</vs-td>
                <vs-td :data="pr.notificationScheduleID">{{ scheduleName(pr.notificationScheduleID) }}</vs-td>
                <vs-td>
                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    @click.stop="editProfile(pr)" />
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current ml-2"
                    @click.stop="deleteProfile(pr)" />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-2">
              <vs-input label="Profile Name" v-model="profileFormData.name" class="w-full" />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-2">
              <label class="w-full">Schedule</label>
              <v-select :options="notificationSchedules" placeholder="Select Schedule"
                v-model="profileFormData.schedule" />
            </div>
          </div>
          <div class="vx-row mt-3">
            <div class="vx-col mb-2">
              <vs-checkbox v-model="profileFormData.continuous">Continuous Notification</vs-checkbox>
            </div>
          </div>

          <vs-button class="rounded-lg mt-3 mr-3" color="success" type="border" @click="saveProfile()">
            {{ profileFormData.id ? 'Update Profile' : 'Add Profile' }}
          </vs-button>
          <vs-button class="rounded-lg mt-3 mr-3" color="warning" type="border" @click="initProfileForm()">Clear
          </vs-button>
          <vs-button class="rounded-lg mt-3 mr-3" color="dark" type="border" @click="popupManageProfiles = false">
            Close
          </vs-button>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import VueQRCodeComponent from 'vue-qrcode-component';
import { selected } from "@syncfusion/ej2-vue-pivotview";
export default {
  data() {
    return {

      title: 'FAMS - new Information Wizard!!',
      subtitle: 'Please complete each field to add new Information',

      itemsPerPage: 10,
      selected: [],
      isMounted: false,
      isListHidden: false,
      isInfoHidden: true,
      registeredBot: '',
      registeredBotUrl: '',
      continuous: false,
      formData: {
        id: 0,
        name: '',
        surname: '',
        phoneNumber: '',
        emailaddress: '',
        enabled: false,
        notifications: [],
        atgNotifications: [],
        fmsNotifications: [],
        iotNotifications: [],
        notificationScheduleId: 0
      },

      selected: [],
      contactInfoData: [],

      chatBots:[],
      selectedChatBot: {label: 'N/A', value: 0},
      selectedSchedule: {label: 'N/A', value: 0},
      popupContactInfo: false,
      popupGenerateQR: false,
      popupManageProfiles: false,
      notificationTypes: [],
      notificationSchedules: [],
      notificationProfiles: [],
      profileFormData: {
        id: 0,
        name: '',
        continuous: false,
        schedule: {label: 'N/A', value: 0}
      },
    };
  },
  components: {
    flatPickr,
    "v-select": vSelect,
    FormWizard,
    TabContent,
    qrCode: VueQRCodeComponent,
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.gridTable.currentx;
      }
      return 0;
    }
  },
  watch: {

  },
  mounted() {
    this.GetContactInfo();
    this.getChatBotDropdown();
    this.getNotificationTypes();
    this.getNotificationSchedules();
    this.getNotificationProfiles();
    this.isMounted = true;
  },
  methods: {
    successNotify() {
      this.$vs.notify({
        title: 'Successfully',
        text: 'Item successfully added | updated | removed',
        color: 'success'
      })
    },
    FailedNotify() {
      this.$vs.notify({
        title: 'Not Successfull',
        text: 'Item not added',
        color: 'danger'
      })
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    cancelAdd() {
      this.isListHidden = false;
      this.isInfoHidden = true;
      this.initValues();
      this.GetContactInfo();
    },
    addContactInfo() {
      this.initValues();
      this.isInfoHidden = false;
      this.isListHidden = true;
    },

    initValues() {
      var self = this;

      self.formData.id = 0;
      self.formData.name = '';
      self.formData.surname = '';
      self.formData.phoneNumber = '';
      self.formData.emailaddress = '';
      self.formData.notificationScheduleId = 0;
      self.formData.enabled = false;

      self.registeredBot = '';
      self.registeredBotUrl = '';
      self.chatBots = [];
      self.notificationTypes = [];
      self.notificationSchedules = [];
      self.selectedChatBot = {label: 'N/A', value: 0};
      self.getChatBotDropdown();
      self.getNotificationTypes();
      self.getNotificationSchedules();
      self.getNotificationProfiles();
    },
    GetContactInfo() {
      const self = this;
      // self.showLoadingOnElement("gridTable", 1, "radius");
      var onSuccess = function (response) {
        self.contactInfoData = response.data;
      };
      var onFinally = function () {

        self.getChatBotDropdown();
        self.getNotificationTypes();
        self.getNotificationSchedules();
        // self.$vs.loading.close(self.$refs.gridTable.$el);
      };
      self.$ajaxGet(
        self,
        "IOTReporting",
        onSuccess,
        onFinally
      );
    },
    onNotificationChange(type) {
      var self = this;
      const name = type.name || "";
      const code = type.code || "";
      const prefix = name.split("-")[0].trim(); // Extract group e.g. "FMS"

      // ---------------------------------------
      // CASE 3: The user (un)checked "FMS - ALL" — every item in that group should
      // follow ALL's new state, whether that's selecting or deselecting everything.
      // ---------------------------------------
      if (code.toUpperCase() === "ALL") {
        let groupItems = null;
        switch (name) {
          case "ATG":
            groupItems = self.formData.atgNotifications;
            break;
          case "FMS":
            groupItems = self.formData.fmsNotifications;
            break;
          case "Notification":
            groupItems = self.formData.notifications;
            break;
          case "FMC":
            groupItems = self.formData.iotNotifications;
            break;
          default:
            break;
        }

        if (groupItems) {
          groupItems.forEach(item => {
            item.isSelected = type.isSelected;
          });
        }
        return;
      }

      // ---------------------------------------
      // CASE 4: User changed an item in a group (e.g., FMS - Dispensing)
      // → If user unticks it, turn the "ALL" option OFF
      // → If all sub-items get ticked, auto-select "ALL"
      // ---------------------------------------
      switch (name) {
        case "ATG":
          const allItemATG = self.formData.atgNotifications.find(
            x => x.code.toUpperCase() === "ALL"
          );

          if (allItemATG) {
            const groupItemsATG = self.formData.atgNotifications.filter(
              x => x.code.toUpperCase() !== "ALL"
            );

            const allCheckedATG = groupItemsATG.every(x => x.isSelected);

            // If self item was unchecked → uncheck the ALL item
            if (!type.isSelected) {
              allItemATG.isSelected = false;
            } else {
              // If all items now checked → check ALL
              allItemATG.isSelected = allCheckedATG;
            }
          }
          break;
        case "Notification":
          const allItem = self.formData.notifications.find(
            x => x.code.toUpperCase() === "ALL"
          );

          if (allItem) {
            const groupItems = self.formData.notifications.filter(
              x => x.code.toUpperCase() !== "ALL"
            );

            const allChecked = groupItems.every(x => x.isSelected);

            // If self item was unchecked → uncheck the ALL item
            if (!type.isSelected) {
              allItem.isSelected = false;
            } else {
              // If all items now checked → check ALL
              allItem.isSelected = allChecked;
            }
          }
          break;
        case "FMS":
          const allItemFMS = self.formData.fmsNotifications.find(
            x => x.code.toUpperCase() === "ALL"
          );

          if (allItemFMS) {
            const groupItemsFMS = self.formData.fmsNotifications.filter(
              x => x.code.toUpperCase() !== "ALL"
            );

            const allCheckedFMS = groupItemsFMS.every(x => x.isSelected);

            // If self item was unchecked → uncheck the ALL item
            if (!type.isSelected) {
              allItemFMS.isSelected = false;
            } else {
              // If all items now checked → check ALL
              allItemFMS.isSelected = allCheckedFMS;
            }
          }
          break;
        case "FMC":
          const allItemIOT = self.formData.iotNotifications.find(
            x => x.code.toUpperCase() === "ALL"
          );

          if (allItemIOT) {
            const groupItemsIOT = self.formData.iotNotifications.filter(
              x => x.code.toUpperCase() !== "ALL"
            );

            const allCheckedIOT = groupItemsIOT.every(x => x.isSelected);

            // If self item was unchecked → uncheck the ALL item
            if (!type.isSelected) {
              allItemIOT.isSelected = false;
            } else {
              // If all items now checked → check ALL
              allItemIOT.isSelected = allCheckedIOT;
            }
          }
          break;
        default:
          break;
      }
    },
    // Setting ALL's own profile pushes that profile to every item in its group (a one-time
    // push, not a continuous sync) — so someone can still pick a different profile for an
    // individual item afterward and have that stick. Changing an individual item's own
    // profile does nothing here; only ALL's picker triggers this.
    onProfileChange(type, newProfile) {
      var self = this;
      if ((type.code || "").toUpperCase() !== "ALL") return;

      const name = type.name || "";
      let groupItems = null;
      switch (name) {
        case "ATG":
          groupItems = self.formData.atgNotifications;
          break;
        case "FMS":
          groupItems = self.formData.fmsNotifications;
          break;
        case "Notification":
          groupItems = self.formData.notifications;
          break;
        case "FMC":
          groupItems = self.formData.iotNotifications;
          break;
        default:
          break;
      }

      if (groupItems) {
        groupItems.forEach(item => {
          if (item.code.toUpperCase() === "ALL") return;
          item.profile = newProfile;
        });
      }
    },
    saveContactInfo() {
      var self = this;
      self.formData.notificationScheduleId = self.continuous ? self.selectedSchedule.value || 0 : 0;

      var myobject = {
        userContactInfo: {
          id: self.formData.id,
          name: self.formData.name,
          surname: self.formData.surname,
          phoneNumber: self.formData.phoneNumber.includes("+") ? self.formData.phoneNumber.replace("+", "") : self.formData.phoneNumber,
          emailaddress: self.formData.emailaddress,
          wChatBotId: self.selectedChatBot.value || 0,
          notificationScheduleId: self.formData.notificationScheduleId,
          continuousNotify: self.continuous ? 1 : 0
        },
        atgNotifications: [],
        fmsNotifications: [],
        notifications: [],
        iotNotifications: []
      };

      myobject.atgNotifications = self.formData.atgNotifications
        .filter(item => item.isSelected)
        .map(item => ({
          id: item.id || null,
          code: item.code || null,
          description: item.description || null,
          name: item.name || null,
          profileId: (item.profile && item.profile.value) || null
        }));

      myobject.fmsNotifications = self.formData.fmsNotifications
        .filter(item => item.isSelected)
        .map(item => ({
          id: item.id || null,
          code: item.code || null,
          description: item.description || null,
          name: item.name || null,
          profileId: (item.profile && item.profile.value) || null
        }));

      myobject.notifications = self.formData.notifications
        .filter(item => item.isSelected)
        .map(item => ({
          id: item.id || null,
          code: item.code || null,
          description: item.description || null,
          name: item.name || null,
          profileId: (item.profile && item.profile.value) || null
        }));

      myobject.iotNotifications = self.formData.iotNotifications
        .filter(item => item.isSelected)
        .map(item => ({
          id: item.id || null,
          code: item.code || null,
          description: item.description || null,
          name: item.name || null,
          profileId: (item.profile && item.profile.value) || null
        }));

      // self.showLoadingOnElement("gridTable", 1, "radius");
      var onSuccess = function (response) {
        if(self.popupContactInfo == true){
          self.isListHidden = false;
          self.isInfoHidden = true;
          self.initValues();
          self.popupContactInfo = false;
          self.GetContactInfo();
        }
        else{
          self.isListHidden = false;
          self.isInfoHidden = true;
          self.initValues();
          self.GetContactInfo();
        }
        // self.GetGrid();
        //self.GetGrid();
      };
      var onFinally = function () {
        // self.$vs.loading.close(self.$refs.gridTable.$el);
        self.successNotify();
      };
      self.$ajaxPost(
        self,
        "IOTReporting",
        myobject,
        onSuccess,
        onFinally
      );
    },
    deleteContactInfo(data){
      var self = this;

      // self.showLoadingOnElement("gridTable", 1, "radius");
      var onSuccess = function(response) {
        self.GetContactInfo();
      };
      var onFinally = function() {
        // self.$vs.loading.close(self.$refs.gridTable.$el);
         self.successNotify();
      };
      self.$ajaxDelete(
        self,
        "IOTReporting/" + data.id,
        onSuccess,
        onFinally
      );
    },
    openContactInfoPopup(data) {
      let self = this;

      // Basic fields
      self.formData.id = data.id;
      self.formData.name = data.name;
      self.formData.surname = data.surname;
      self.formData.phoneNumber = data.phoneNumber;
      self.formData.emailaddress = data.emailaddress;
      self.formData.enabled = data.enabled;
      self.continuous = data.continuous,
      self.selectedSchedule = self.notificationSchedules.filter(function (item) {
          return item.value === data.scheduleId;
        });
      // Select bot
      self.selectedChatBot = {
        label: data.chatBot,
        value: data.wChatBotId
      };

      // Reset all checkboxes (and profile assignment) before populating
      self.formData.notifications.forEach(x => { x.isSelected = false; x.profile = null; });
      self.formData.atgNotifications.forEach(x => { x.isSelected = false; x.profile = null; });
      self.formData.fmsNotifications.forEach(x => { x.isSelected = false; x.profile = null; });
      self.formData.iotNotifications.forEach(x => { x.isSelected = false; x.profile = null; });

      // -------------------------------------------------
      // 1️⃣ POPULATE GENERAL TELEGRAM NOTIFICATIONS
      // data.chatbotTypes → formData.notifications / atgNotifications / fmsNotifications
      // -------------------------------------------------
      data.iotChatbotTypes.forEach(saved => {

        // Step 1: pick the correct list based on typeName
        let list = null;

        switch (saved.typeName) {
          case "Notification":
            list = self.formData.notifications;
            break;

          case "ATG":
            list = self.formData.atgNotifications;
            break;

          case "FMS":
            list = self.formData.fmsNotifications;
            break;

          case "FMC":
            list = self.formData.iotNotifications;
            break;
        }

        if (!list) return;

        // Step 2: match using typeCode → code
        const match = list.find(x => x.code === saved.typeCode);

        // Step 3: set checkbox state + restore this type's own profile assignment, if any
        if (match) {
          match.isSelected = true;

          const savedProfileId = saved.notificationProfileID || saved.notificationProfileId || null;
          match.profile = savedProfileId
            ? self.notificationProfiles.find(p => p.value === savedProfileId) || null
            : null;
        }
      });

      // Finally show popup
      self.popupContactInfo = true;
    },
    closeContactInfoPopup(){
      var self = this;
      self.popupContactInfo = false;
      self.initValues();
    },
    generateQR(tr){
      var self = this;
      self.registeredBotUrl = tr.botURL;
      self.registeredBot = tr.chatBot;

      this.popupGenerateQR = true;
    },
    getChatBotDropdown(){
      var self = this;
      const onSuccess = function(response){
        self.chatBots = response.data.map(function (item) {
          return { label: item.name, value: item.id };
        });
      };
      const onFinally = function(){

      };
      self.$ajaxGet(
        self,
        "UserContactInfo/GetChatBotsDropdown",
        onSuccess,
        onFinally
      );
    },
    getNotificationTypes(){
      var self = this;
      const onSuccess = function(response){
        // "profile" must exist on every item up front (even as null) for Vue 2 to track
        // later assignments to it reactively.
        const withProfile = response.data.map(item => ({ ...item, profile: null }));

        self.formData.notifications = withProfile.filter(function (item) {
          return item.name == "Notification";
        });
        self.formData.atgNotifications = withProfile.filter(function (item) {
          return item.name == "ATG";
        });
        self.formData.fmsNotifications = withProfile.filter(function (item) {
          return item.name == "FMS";
        });
        self.formData.iotNotifications = withProfile.filter(function (item) {
          return item.name == "FMC";
        });

        // self.formData.iotNotifications = response.data.iotReportTypes;
      };
      const onFinally = function(){

      };
      self.$ajaxGet(
        self,
        "IOTReporting/GetNotificationTypes",
        onSuccess,
        onFinally
      );
    },
    getNotificationSchedules(){
      var self = this;
      const onSuccess = function(response){
        self.notificationSchedules = response.data.map((item) => { return { label: item.name, value: item.id } });
      };
      const onFinally = function(){

      };
      self.$ajaxGet(
        self,
        "IOTReporting/GetNotificationSchedules",
        onSuccess,
        onFinally
      );
    },
    getNotificationProfiles(){
      var self = this;
      const onSuccess = function(response){
        // label/value for the v-select assignment picker; name/continuousNotify/notificationScheduleID
        // (mirroring the raw API shape) for the management table below.
        self.notificationProfiles = response.data.map((item) => {
          return {
            label: item.name,
            value: item.id,
            name: item.name,
            continuousNotify: item.continuousNotify,
            notificationScheduleID: item.notificationScheduleID
          };
        });
      };
      const onFinally = function(){

      };
      self.$ajaxGet(
        self,
        "IOTReporting/GetNotificationProfiles",
        onSuccess,
        onFinally
      );
    },
    scheduleName(scheduleId){
      var self = this;
      const match = self.notificationSchedules.find(s => s.value === scheduleId);
      return match ? match.label : 'N/A';
    },
    openManageProfiles(){
      var self = this;
      self.initProfileForm();
      self.getNotificationProfiles();
      self.popupManageProfiles = true;
    },
    initProfileForm(){
      var self = this;
      self.profileFormData = {
        id: 0,
        name: '',
        continuous: false,
        schedule: {label: 'N/A', value: 0}
      };
    },
    editProfile(profile){
      var self = this;
      self.profileFormData = {
        id: profile.value,
        name: profile.label,
        continuous: profile.continuousNotify == 1,
        schedule: self.notificationSchedules.find(s => s.value === profile.notificationScheduleID) || {label: 'N/A', value: 0}
      };
    },
    saveProfile(){
      var self = this;
      if (!self.profileFormData.name) {
        self.$vs.notify({ title: 'Profile name required', text: 'Please enter a name for this profile', color: 'danger' });
        return;
      }

      var payload = {
        id: self.profileFormData.id,
        name: self.profileFormData.name,
        continuousNotify: self.profileFormData.continuous ? 1 : 0,
        notificationScheduleID: self.profileFormData.schedule.value || 0
      };

      var onSuccess = function(response) {
        self.initProfileForm();
        self.getNotificationProfiles();
      };
      var onFinally = function() {
        self.successNotify();
      };
      self.$ajaxPost(
        self,
        "IOTReporting/NotificationProfile",
        payload,
        onSuccess,
        onFinally
      );
    },
    deleteProfile(profile){
      var self = this;

      var onSuccess = function(response) {
        self.getNotificationProfiles();
      };
      var onFinally = function() {
        self.successNotify();
      };
      self.$ajaxDelete(
        self,
        "IOTReporting/NotificationProfile/" + profile.value,
        onSuccess,
        onFinally
      );
    },
  }
};

</script>
<style>
#iconContainer span {
  display: flex;
  justify-content: space-evenly;
}

#iconContainer span .con-vs-tooltip {
  padding: 0px 1px;
}

/* ---- IOTNotifyUsers layout: contact-details / chat-bot / notification-types / schedule ---- */

.notify-section {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 16px 20px 20px;
  margin-bottom: 20px;
}

.notify-section-title {
  font-weight: 600;
  margin: 0 0 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.notify-hint {
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.8rem;
  margin: 0;
}

.notify-type-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

@media (max-width: 768px) {
  .notify-type-grid {
    grid-template-columns: 1fr;
  }
}

.notify-type-card {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.notify-type-card-header {
  background: rgba(var(--vs-primary), 0.08);
  padding: 8px 14px;
  font-weight: 600;
  font-size: 0.85rem;
}

.notify-type-card-body {
  max-height: 280px;
  overflow-y: auto;
  padding: 6px 14px;
}

.notify-type-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.08);
}

.notify-type-row:last-child {
  border-bottom: none;
}

.notify-type-row--all {
  font-weight: 600;
}

.notify-type-profile-select {
  min-width: 150px;
  max-width: 170px;
  margin-left: 10px;
  flex-shrink: 0;
}

/* Vuesax's vs-popup has no width prop, so this scales the Edit Contact popup's own container
   (it forwards the "class" attribute to its root element) to fit the notification-type grid. */
.notify-wide-popup.vs-popup,
.notify-wide-popup .vs-popup {
  width: 95%;
  max-width: 1100px;
}
</style>
